import React from "react";
import "./styles.scss";
var MainSliderProgressBar = function (props) {
    return (React.createElement("div", { className: "c-MainSlider__progressBar" },
        React.createElement("span", { className: "c-MainSlider__progressBarFill" })));
};
export default MainSliderProgressBar;
